export default [
	require('@img/emoji-codes/1.png'),
	require('@img/emoji-codes/2.png'),
	require('@img/emoji-codes/3.png'),
	require('@img/emoji-codes/4.png'),
	require('@img/emoji-codes/5.png'),
	require('@img/emoji-codes/6.png'),
	require('@img/emoji-codes/7.png'),
	require('@img/emoji-codes/8.png'),
	require('@img/emoji-codes/9.png')
]